import { RESULTS_BASE_URLS } from '../../config/constants';

const isResultsUrlExternal = (resultsUrl: string): boolean => {
  try {
    const resultsUrlHostname = new URL(resultsUrl).hostname;

    return !Object.values(RESULTS_BASE_URLS).some((baseHostname) =>
      baseHostname.includes(resultsUrlHostname)
    );
  } catch (_error) {
    return false;
  }
};

export default isResultsUrlExternal;
